<template>
  <div>
  <section id="top_visual">
    <p>가치 향상에 기여하는 혁신적인 경영 지원 플랫폼</p>
    <span>Etners business management platform</span>
  </section>
    <main id="page_main">
      <section id="page_contents">
        <h3>다양한 사업지원 서비스를 만나 보세요</h3>
        <!---비즈니스--->
        <ul class="business">
          <li>
            <p><a @click="openIntroducePage('Shop')" style="cursor: pointer" title="이트너스샵"><img src="../assets/images/bs_ic_02.png" alt="이트너스샵"/></a></p>
            <span>Etners shop</span>
          </li>
          <li>
            <p><a @click="openIntroducePage('Bidding')" style="cursor: pointer" title="이트너스비딩"><img src="../assets/images/bs_ic_04.png" alt="이트너스비딩"/></a></p>
            <span>Etners bidding </span>
          </li>
          <li>
            <p><a @click="openIntroducePage('Payroll')" style="cursor: pointer" title="페이롤"><img src="../assets/images/bs_ic_06.png" alt="페이롤"/></a></p>
            <span>Etners payroll</span>
          </li>
          <li>
            <p><a @click="openIntroducePage('Chongmu')" style="cursor: pointer" title="Chongmu"><img src="../assets/images/bs_ic_08.png" alt="Chongmu"/></a></p>
            <span>Chongmu </span>
          </li>
          <li>
            <p><a @click="openIntroducePage('Mall')" style="cursor: pointer" title="이트너스몰"><img src="../assets/images/bs_ic_03.png" alt="이트너스몰"/></a></p>
            <span>Etners mall</span>
          </li>

          <li>
            <p><a @click="openIntroducePage('Moving')" style="cursor: pointer" title="이트너스무빙"><img src="../assets/images/bs_ic_01.png" width="82" height="92" alt="이트너스무빙"/></a></p>
            <span>Etners moving</span>
          </li>
          <li>
            <p><img src="../assets/images/bs_ic_07_dis.png" alt="dms"/></p>
            <span>Etners dms </span>
          </li>

          <li>
            <p><img src="../assets/images/bs_ic_05_dis.png" alt="하우징샵"/></p>
            <span>Housing shop </span>
          </li>
          <li v-if="userData.solCds.includes(1022)">
            <p><a @click="openDsMovePage()" style="cursor: pointer" title="DS 무브 사내이사">
              <img src="../assets/images/dsmov_web_icon.png" alt="사내이사"/>
            </a></p>
            <span>사내 이사</span>
          </li>



        </ul>
        <!---//비즈니스--->
      </section>

      <!-- 경영지원플랫폼 관리자 -->
<!--      <section v-if="this.$store.state.userStore.userInfo.solutionMap !== undefined" id="page_contents" class="btline">-->
        <section v-if="userData.epcAdminAuthCd === '99999'" id="page_contents" class="btline">
          <h4>경영지원 플랫폼 관리자</h4>
          <ul class="platform" v-if="userData.solCds.includes(epcAdminSolCd)">
            <li>
              <dl>
                <dt>Admin
                  <a href="#">
                    <img v-bind:src="`${platformDomain}/files/solutionImages/${epcAdminSolCd}`" width="50" height="50" align="absmiddle" alt="">
                    <img style="-webkit-filter: grayscale(100%);filter: gray;" v-bind:src="`${platformDomain}/files/solutionImages/${epcAdminSolCd}`" width="50" height="50" align="absmiddle" alt="">
                  </a><span></span></dt>
                <dd class="dlink">
                  <button type="button" id="adminButton" data-role="button" class="hyperButton" role="button" aria-disabled="false" tabindex="0" @click="goEpcAdminSolutionUrl"><span class="k-icon k-i-hyperlink-open-sm" style="cursor: pointer"></span>바로가기</button>
                </dd>
              </dl>
            </li>
          </ul>
      </section>
      <!-- //경영지원플랫폼 관리자 -->

<!--      <section v-if="this.$store.state.userStore.userInfo.solutionMap !== undefined" id="page_contents" class="btline">
        <h4>경영지원 서비스</h4>
        <ul class="platform">
          <li v-for="(sMap, key) in this.$store.state.userStore.userInfo.solutionMap" v-if="(sMap.solGrup != '10'&&sMap.solGrup != '00')||sMap.solCd =='0001'">
            <dl>
              <dt>{{sMap.solNm}}
                <a href="#">
                  <img v-bind:src="`${platformDomain}/files/solutionImages/${sMap.solCd}`" width="50" height="50" align="absmiddle" alt="" v-if="checkAllowShortcuts(sMap.solCd,sMap.authCd)">
                  <img style="-webkit-filter: grayscale(100%);filter: gray;" v-bind:src="`${platformDomain}/files/solutionImages/${sMap.solCd}`" width="50" height="50" align="absmiddle" alt="" v-if="!checkAllowShortcuts(sMap.solCd,sMap.authCd)">
              </a><span></span></dt>
              <dd><a href="#">{{sMap.solDesc}}</a></dd>
              <dd class="dlink">
                <button type="button" id="iconButton" data-role="button" class="hyperButton" role="button" aria-disabled="false" tabindex="0" @click="goSolutionUrl(sMap.solUrl,sMap.solCd)"  v-if="checkAllowShortcuts(sMap.solCd,sMap.authCd)"><span class="k-icon k-i-hyperlink-open-sm" style="cursor: pointer"></span>바로가기</button>
                <button type="button" id="iconButtonOpen" data-role="button" class="hyperButton" role="button" aria-disabled="false" tabindex="0" @click="openIntroducePage(sMap.solCd,sMap.authCd)"><span class="k-icon k-i-window"></span>자세히보기</button>
              </dd>
            </dl>
          </li>
        </ul>
        &lt;!&ndash;- //플랫폼리스트 -&ndash;&gt;
      </section>-->
    </main>
  </div>
</template>

<script>
  import JwtService from "../common/jwt.service";
  import ApiUtil from "../api/api.util";
  import ApiConfig from "../api/api.config"

  export default {
   data() {

     const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
     const loginUserData = JSON.parse(sessionStorage.getItem('loginUserData'))

     let epcAdminUrl = location.hostname.includes('dev') || location.hostname.includes('localhost') ? 'https://dev-a-epc.etnersplatform.com' : 'https://a-epc.etnersplatform.com'
     if(location.hostname.includes('localhost')) {
       epcAdminUrl = 'http://localhost:8080'
     }
     let dsMoveUrl = location.hostname.includes('dev') || location.hostname.includes('localhost') ? 'https://dev-gdm.etnersplatform.com/etners-platform/login' : 'https://gdm.dsmove.co.kr/etners-platform/login'

      return {
        platformDomain: ApiConfig.platformDomain,
        epcAdminUrl,
        dsMoveUrl,
        epcAdminSolCd: '0001',
        //test
        userData: {
          authCd: loginUserData.authCd,
          epcAdminAuthCd: '',
          lutk: userInfo.loginUserToken,
          solCds: userInfo.solCd,
        }
      }
    },
    mounted: function() {

     const vm = this

     // 사용자의 경영지원플랫폼 관리자 솔루션 권한코드 조회
      ApiUtil.post(`${ApiConfig.singleDomain}/v1/ebmp/solution/user/firstAccessInfo.json`, {
        loginUserToken: sessionStorage.lutk,
        currentSolcd: '0001'
      })
      .then(response => {

        const result = response.data
        if (result.resultStatus.messageCode === '2000') {

          vm.userData.epcAdminAuthCd = result.resultData.authCd
        }
      })
    },
    methods:{
      /*goSolutionUrl: function (solutionUrl,solCd) {

        if(solCd === '0001'){

          window.open('#/admin')

        } else if (solutionUrl !== '' && solutionUrl != null) {
            let lutk = JwtService.getToken()

            window.open(solutionUrl+'?loginUserToken='+lutk)

        } else {
          this.$router.push({name: 'Main'})
        }
      },*/
      // EPC 관리자 웹 진입
      goEpcAdminSolutionUrl: function() {

        let lutk = JwtService.getToken()
        window.open(this.epcAdminUrl+'?loginUserToken='+lutk+'&userSolCds='+this.userData.solCds)
      },

      openIntroducePage : function(solution){
        this.$router.push({name: `Introduce${solution}`})
      },

      checkAllowShortcuts : function (solutionCode,authCd) {

        const openSolutionCode = ["0001","1000", "1001", "1007", "1002"]
        return -1 !== openSolutionCode.indexOf(solutionCode);
      },

      openDsMovePage : function () {
        let lutk = JwtService.getToken()
        window.open(this.dsMoveUrl+'?loginUserToken='+lutk)
      },

  }
}
</script>

